<template>
  <div class="wrapper">
    <div class="container-1200">
      <div class="account-title flex items-center py-6">
        <span class="text-lg">个人中心</span>
      </div>
      <div class="account-content flex pb-[20px]">
        <div class="account-left custom-scrollbar w-[310px] overflow-y-auto overflow-x-hidden rounded-lg bg-[#f8f9fd]">
          <!-- 左侧边栏 -->
          <div class="my-item my-info flex flex-col items-center text-center">
            <el-image :src="$store.state.avatar" class="my-2 h-[70px] w-[70px] rounded-[50%]" />
            <p class="mb-4 text-lg">你好</p>
            <p class="mb-4 text-sm text-gray-600">{{ $store.state.name }}</p>
            <p
              class="cursor-pointer rounded border border-gray-200 px-5 py-1 text-sm text-gray-600"
              @click="tab = '个人信息'"
            >
              个人信息
            </p>
          </div>
          <div class="my-item my-deliver" :class="{ on: tab === '我的投递' }" @click="changeTab('我的投递')">
            <div class="my-item-title">我的投递</div>
            <div class="my-item-line">
              已投递过的职位数：<span>{{ deliveryCount }}</span>
            </div>
            <i class="el-icon-arrow-right absolute right-2 top-1/2 -translate-y-1/2 text-gray-400"></i>
          </div>
          <div class="my-item my-deliver" :class="{ on: tab === '我的收藏' }" @click="changeTab('我的收藏')">
            <div class="my-item-title">我的收藏</div>
            <div class="my-item-line">
              已收藏的职位数：<span>{{ collectCount }}</span>
            </div>
            <i class="el-icon-arrow-right absolute right-2 top-1/2 -translate-y-1/2 text-gray-400"></i>
          </div>
          <div class="my-item my-resume" :class="{ on: tab === '简历管理' }" @click="changeTab('简历管理')">
            <div class="my-item-title">简历管理</div>
            <div class="my-item-line">
              已创建简历数：<span>{{ resumeCount }}</span>
            </div>
            <i class="el-icon-arrow-right absolute right-2 top-1/2 -translate-y-1/2 text-gray-400"></i>
          </div>
        </div>
        <!-- 右边栏 -->
        <div class="account-right custom-scrollbar ml-10 flex-1 overflow-y-auto rounded-lg bg-[#f8f9fd] p-[20px]">
          <!-- 个人信息 -->
          <div v-if="tab === '个人信息'">
            <AccountInfo />
          </div>

          <!-- 我的投递 -->
          <div v-if="tab === '我的投递'" class="">
            <NoData
              text="没有投递记录哦"
              text2="快去挑选职位吧"
              image="account-send.png"
              v-if="deliveryCount === 0"
            ></NoData>
            <AccountPositionList v-else />
          </div>

          <!-- 我的收藏 -->
          <div v-if="tab === '我的收藏'" class="">
            <NoData
              text="没有收藏记录哦"
              text2="快去挑选职位吧"
              image="account-send.png"
              v-if="collectCount === 0"
            ></NoData>
            <AccountCollection v-else />
          </div>

          <!-- 简历管理 -->
          <div v-if="tab === '简历管理'">
            <NoData
              text="您还没有简历哦"
              text2="通过以下方法来快速新建一份简历吧"
              image="account-resume.png"
              to="resume"
              to-text="新建简历"
              v-if="resumeCount === 0"
            ></NoData>
            <AccountResumeList v-else />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/utils/eventbus';
import NoData from '@/components/NoData.vue';
import AccountInfo from '@/components/AccountInfo.vue';
import AccountPositionList from '@/components/AccountPositionList.vue';
import AccountResumeList from '@/components/AccountResumeList.vue';
import AccountCollection from '@/components/AccountCollection.vue';
import { collectList } from '@/api/position';
import { resumeList, resumeDelivery } from '@/api/user-center';

export default {
  name: 'AccountView',
  components: {
    NoData,
    AccountInfo,
    AccountPositionList,
    AccountResumeList,
    AccountCollection,
  },
  data() {
    return {
      tab: '我的投递',
      resumeCount: 0,
      deliveryCount: 0,
      collectCount: 0,
    };
  },
  methods: {
    getData() {
      // 获取简历数量
      resumeList()
        .then((res) => {
          this.resumeCount = res.data.count;
        })
        .catch((error) => {});
      // 获取投递数量
      resumeDelivery()
        .then((res) => {
          this.deliveryCount = res.data.total;
        })
        .catch((error) => {});
      // 获取收藏数量
      collectList()
        .then((res) => {
          this.collectCount = res.data.total;
        })
        .catch((error) => {});
    },
    // 切换tab
    changeTab(tab) {
      if (!tab || this.tab === tab) return;

      this.tab = tab;
      this.$router.push({ query: { tab: tab } }, () => {}); // 在使用this.$router.push 跳转页面时候，重复进入当前路由或报错，这里传个reject promise解决
    },
  },
  mounted() {
    this.changeTab(this.$route.query.tab);
    this.getData();
    EventBus.$on('update-count', () => {
      this.getData();
    });
  },
};
</script>

<style lang="scss" scoped>
.account-content {
  height: calc(100vh - 80px - 76px);
}
.my-item {
  padding: 30px;
  border-bottom: 1px solid #f5f5f5;
  position: relative;
  cursor: pointer;

  &-title {
    font-size: 16px;
    color: #4b4b4b;
    font-weight: 700;
    margin-bottom: 10px;
  }

  &-line {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.45);
    line-height: 2em;
    & span {
      text-decoration: underline;
      color: #333;
    }
  }

  &.on {
    border-left: 3px solid #000;
  }
}
.my-item:hover {
  // background-color: #fafafa;
}
</style>
